// Output instances placed in the Configure > Output tab. Each selected output
// (Text / Image / Video / Button) can be added multiple times; every instance
// has a position/size (percent of the screen) and an auto name (Text 1, ...).
// Text/Image/Video instances are ACTION targets; Button instances are on-screen
// buttons (inputs) usable in the decision panel.
const KEY = 'aiCodeOutputs'

export const OUTPUT_TYPES = {
    text: { label: 'Text', w: 60, h: 12 },
    image: { label: 'Image', w: 32, h: 24 },
    video: { label: 'Video', w: 40, h: 30 },
    // Audio has no required visual: a small speaker marker is placed so it can
    // be positioned, and it can be hidden (invisible) while still playing.
    audio: { label: 'Audio', w: 16, h: 10 },
    button: { label: 'Button', w: 24, h: 10 },
    // Latching on/off switch: an on-screen control usable as a decision input.
    toggle: { label: 'Toggle', w: 26, h: 12 },
}

export const DISPLAY_TYPES = ['text', 'image', 'video', 'audio'] // action targets

const rnd = () => Math.random().toString(36).slice(2, 8)

export function loadOutputs() {
    try {
        const v = JSON.parse(sessionStorage.getItem(KEY))
        return Array.isArray(v) ? v : []
    } catch {
        return []
    }
}

export function saveOutputs(list) {
    sessionStorage.setItem(KEY, JSON.stringify(list))
}

// Add an instance of `type`, named `<Type> N` (N = count of that type + 1),
// cascaded so it doesn't land exactly on top of the previous one.
export function addOutput(list, type) {
    const meta = OUTPUT_TYPES[type]
    if (!meta) return list
    const n = list.filter((o) => o.type === type).length + 1
    const offset = (list.length % 6) * 4
    return [
        ...list,
        {
            id: rnd(),
            type,
            name: `${meta.label} ${n}`,
            x: Math.min(70, 8 + offset),
            y: Math.min(80, 8 + offset),
            w: meta.w,
            h: meta.h,
        },
    ]
}

export function instancesOfType(list, type) {
    return list.filter((o) => o.type === type)
}
